import React, { useEffect, useState, useMemo, useContext } from "react";
import { IconButton } from "@mui/material";
import { useLocation } from "react-router-dom";

import { DataGrid, Icon } from "../../../components";
import { LoginContext } from "../../../context/login-context";
//todo make this reusable compenent
const UsersBlock = ({users, onAddEditUser, onRemoveUser, userConfigType, canCrud }) => {

  const columns = [
    {
      field: "name",
      headerName: "Name",
      renderCell: (params) => (
        <div>{`${params?.row?.first_name} ${params?.row?.last_name}`}</div>
      ),
    },
    { field: "email", headerName: "Email" },
    {
      field: "action",
      headerName: "",
      sortable: false,
      align: "right",
      renderCell: (params) => {
        return (
          <>

          <IconButton  >
              <Icon icon="ChevronRight" />
            </IconButton>
          </>
        );
      },
    },
  ];

  return (
    <DataGrid
      toolbarTitle={`${userConfigType} Users`}
      toolbarBtnTitle={`+ Add New ${userConfigType} User`}
      toolbarOnClick={()=>onAddEditUser()}
      toolbarBtnVisible={canCrud} 
      onRowClick={(params) => {
        if(canCrud) onAddEditUser(params?.row);
  		}}
      rows={users}
      columns={columns}
      sx={{
        '& .MuiDataGrid-columnSeparator': {
          display: 'none',
        },
      }}
    />
  );
};

export default UsersBlock;
